module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Icon/ico_arrow-a78c2d3abb523f65aee11d4ec9fb9891.svg";